import React from 'react';
import { CompactVideoCarousel } from './Compact';
import { CompactViewProvider } from './Providers/CompactViewProvider';
import { FullWidthVideoCarousel } from './FullWidth';
export const VideoCarousel = ({ compact, ...props }) => {
    return (React.createElement(CompactViewProvider, { alwaysCompact: compact }, compact ? (React.createElement(CompactVideoCarousel, { ...props })) : (React.createElement(FullWidthVideoCarousel, { ...props }))));
};
